import { Link } from "react-router-dom";
import { Home, RefreshCw, AlertTriangle } from "lucide-react";
import { Logo } from "../components/marketing/MarketingHeader";
import SEO from "../components/SEO";

const ServerErrorPage = ({ message, errorRef }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex flex-col">
      <SEO title="Erreur" description="Une erreur est survenue." noIndex />
      <header className="bg-white border-b border-slate-200">
        <div className="max-w-6xl mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/"><Logo /></Link>
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center px-4 py-12">
        <div className="max-w-2xl w-full bg-white rounded-2xl shadow-lg border border-slate-200 p-8 sm:p-12 text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-red-100 mb-6">
            <AlertTriangle className="w-10 h-10 text-red-600" />
          </div>
          <p className="text-7xl font-bold text-[#19294C] font-['Outfit'] mb-2">500</p>
          <h1 className="text-2xl sm:text-3xl font-bold text-[#19294C] font-['Outfit'] mb-3">
            Une erreur est survenue
          </h1>
          <p className="text-slate-600 mb-2 max-w-md mx-auto">
            {message || "Quelque chose ne s'est pas passé comme prévu de notre côté. L'équipe technique est notifiée."}
          </p>
          <p className="text-sm text-slate-500 mb-8">
            Vous pouvez essayer de recharger la page ou revenir plus tard.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <button
              onClick={() => window.location.reload()}
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-[#00B8E4] text-white font-semibold hover:bg-[#00A0CC] transition-colors"
            >
              <RefreshCw className="w-4 h-4" />
              Recharger la page
            </button>
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full border border-slate-300 text-[#19294C] font-semibold hover:bg-slate-50 transition-colors"
            >
              <Home className="w-4 h-4" />
              Retour à l'accueil
            </Link>
          </div>

          {errorRef && (
            <div className="mt-6 inline-block bg-slate-50 border border-slate-200 rounded-lg px-4 py-2 text-xs font-mono text-slate-500">
              Ref : {errorRef}
            </div>
          )}

          <div className="mt-8 pt-8 border-t border-slate-100 text-sm text-slate-500">
            Le problème persiste ?{" "}
            <a href="mailto:contact@hostprotect.io" className="text-[#00B8E4] hover:underline">
              contact@hostprotect.io
            </a>
          </div>
        </div>
      </main>

      <footer className="bg-white border-t border-slate-200 py-4 text-center text-xs text-slate-500">
        HostProtect — Assurance location courte durée
      </footer>
    </div>
  );
};

export default ServerErrorPage;
